import { render, staticRenderFns } from "./register-pdf.vue?vue&type=template&id=71a3c82a&"
import script from "./register-pdf.vue?vue&type=script&lang=js&"
export * from "./register-pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports